import React from 'react';
import { Box } from '@mui/material';

export interface ICalendarEvent {
  title: string,
    quantity: number,
    eventColor: string,
    borderColor: string,
    completed: boolean,
    end: Date,
    start: Date,
}

type Props = {
  event: ICalendarEvent,
}

const CalendarEvent: React.FC<Props> = ({ event }) => {
  const styles = stylesFunc(event.eventColor, event.borderColor);
  return (
    <Box sx={styles.eventContainer}>
      <Box sx={styles.text}>({event.quantity}) {event.title}</Box>
    </Box>
  )
};

export default CalendarEvent;

const stylesFunc = (eventColor: string, borderColor: string) => ({
  eventContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: '0px 5px',
    border: `1px solid ${borderColor}`,
    borderRadius: '3px',
    backgroundColor: eventColor,
    cursor: 'pointer',
  },
  text: {
    color: borderColor,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
});